module.exports = __webpack_public_path__ + "assets/40deaf3b6b3f70c52ad671c5e98ae86d.jpg";